(function() {
  var Service,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Service = App.loadClass('core::Angular/Service');

  exports.QBQService = (function(superClass) {
    extend(QBQService, superClass);

    function QBQService(http, rootScope) {
      this.http = http;
      this.rootScope = rootScope;
      this.getQueueData = bind(this.getQueueData, this);
      this.triggerSync = bind(this.triggerSync, this);
      void 0;
    }

    QBQService.prototype.triggerSync = function(type, extra) {
      return this.http.post('backend/portal/qbq/trigger-sync', {
        type: type,
        extra: extra
      });
    };

    QBQService.prototype.getQueueData = function() {
      return this.http.post('backend/portal/qbq/get-queue-data');
    };

    return QBQService;

  })(Service);

}).call(this);
